import moment from "moment"
import { useTranslation } from 'react-i18next'

export default function Formatting({ format, children, number, currency, decimalPlaces = 2 }) {
    const { i18n } = useTranslation()

    if (format === 'CURRENCY' || currency) return new Intl.NumberFormat('en', { style: 'currency', currency: 'USD' }).format(children).replace(/US/g, "")

    if (format === 'DATE_SHORT') return moment(children).locale(i18n.language).format('ll')

    if (number) return new Intl.NumberFormat('en', { maximumFractionDigits: decimalPlaces }).format(children)

    if (!children) return null

    return children

}